var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSitemap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_2379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 10.5H3.33333C2.59695 10.5 2 11.097 2 11.8333V13.1667C2 13.903 2.59695 14.5 3.33333 14.5H4.66667C5.40305 14.5 6 13.903 6 13.1667V11.8333C6 11.097 5.40305 10.5 4.66667 10.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 10.5H11.3333C10.597 10.5 10 11.097 10 11.8333V13.1667C10 13.903 10.597 14.5 11.3333 14.5H12.6667C13.403 14.5 14 13.903 14 13.1667V11.8333C14 11.097 13.403 10.5 12.6667 10.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 2.5H7.33333C6.59695 2.5 6 3.09695 6 3.83333V5.16667C6 5.90305 6.59695 6.5 7.33333 6.5H8.66667C9.40305 6.5 10 5.90305 10 5.16667V3.83333C10 3.09695 9.40305 2.5 8.66667 2.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5V9.83333C4 9.47971 4.14048 9.14057 4.39052 8.89052C4.64057 8.64048 4.97971 8.5 5.33333 8.5H10.6667C11.0203 8.5 11.3594 8.64048 11.6095 8.89052C11.8595 9.14057 12 9.47971 12 9.83333V10.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5V8.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_2379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitemap);
export default __webpack_public_path__ + "static/media/sitemap.068bc0d4c3ad7b9fd0d3b2b120d80763.svg";
export { ForwardRef as ReactComponent };